import React from "react";

export const base_url = process.env.REACT_APP_API_URL    